var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Delete, Download, ExpandLess, ExpandMore, MoreVert } from '@mui/icons-material';
import { Box, Chip, Stack, Typography, useMediaQuery } from '@mui/material';
import { useState } from 'react';
import { MoreIconNew } from '../../../../assets/images';
import { ReactComponent as LeftArrow } from '../../../../assets/images/arrow-left.svg';
import { ReactComponent as LinkSvg } from '../../../../assets/images/linkIcon.svg';
import { ReactComponent as ShareIcon } from '../../../../assets/images/shearIcon.svg';
import { DynamicFormBuilderContainer } from '../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { showSurface } from '../../../../redux/awaitedSurfacesSlice';
import { useAppDispatch } from '../../../../store/hooks';
import { systemColor } from '../../../../theme/systemColor';
import { BasicDetailcards } from '../../../spareIssue/components/basicDetailCards';
import CardSummury from '../../../spareIssue/components/cardSummury';
import { PrintIconSVG } from '../../../spareParts/purchaseRequistion/assets/customIcons';
import CQAAcceptReferenceValuePopUp from '../components/CQAAcceptEditReferenceValuePopUp';
import CQAFailFailureReportsCatlog from '../components/CQAFailFailureReportsCatlog';
import CQAHistoryTabReceivedEdit from '../components/CQAHistoryTabReceivedEdit';
import RelatedDocumentsCatalogReceivedEdit from '../components/RelatedDocumentsCatalogReceivedEdit';
import CQAReceivedEditHistoryListViewMobile from '../components/CQAReceivedEditHistoryListViewMobile';
import closeIRPoup from '../components/closeIRPoup';
import AcceptIRPoup from '../components/acceptIRPoup';
import { CloseAFRPopup } from '../../PSG/components/closeAFRpopup';
import RefernceValuepopup from '../../PSG/components/refernceValuepopup';
import CustomerComplaintMobileView from '../components/customerComplaintPopUpMobileView';
var CQAReceivedEdit = function () {
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var dispatch = useAppDispatch();
    var childFFRElements = [{
            type: FormItemTypes.Divider,
            name: 'name',
            variant: 'fullWidth',
            columnSize: 12
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            padding: '12px 16px',
            rowGap: 1,
            elements: [{
                    type: FormItemTypes.CardComponent,
                    name: '',
                    columnSize: 12,
                    containerProps: {
                        m: 0,
                        spacing: 0
                    },
                    sx: {
                        padding: '12px 16px',
                        bgcolor: 'secondary.50',
                        border: 'none',
                        borderRadius: '8px'
                    },
                    contentProps: {
                        spacing: 0,
                        p: 0,
                        rowGap: '4px'
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'RM name',
                            label: 'RM name:',
                            value: null,
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1,
                                spacing: 0
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'ASM name',
                            label: 'ASM name:',
                            value: null,
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1,
                                spacing: 0
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'ASM contact no.',
                            label: 'ASM contact no.:',
                            value: null,
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1,
                                spacing: 0
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'State&city',
                            label: 'State & city:',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1,
                                spacing: 0
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12,
                            setFieldProps: function (formValues, currValue, field) {
                                return {
                                    type: FormItemTypes.Typography,
                                    value: /*#__PURE__*/ React.createElement(Box, {
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center"
                                    }, /*#__PURE__*/ React.createElement(Typography, null, formValues === null || formValues === void 0 ? void 0 : formValues.State), /*#__PURE__*/ React.createElement(Typography, {
                                        mx: 1
                                    }, "|"), /*#__PURE__*/ React.createElement(Typography, null, formValues === null || formValues === void 0 ? void 0 : formValues.City))
                                };
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'Dealer name & code:',
                            label: 'Dealer name & code:',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1,
                                spacing: 0
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12,
                            setFieldProps: function (formValues, currValue, field) {
                                return {
                                    type: FormItemTypes.Typography,
                                    value: /*#__PURE__*/ React.createElement(Stack, null, " ", /*#__PURE__*/ React.createElement(Typography, {
                                        fontSize: 'sm',
                                        fontWeight: 'medium'
                                    }, formValues === null || formValues === void 0 ? void 0 : formValues.Dealername), " ", /*#__PURE__*/ React.createElement(Typography, {
                                        textAlign: 'end',
                                        fontSize: 'sm',
                                        fontWeight: 'medium',
                                        color: 'text.secondary'
                                    }, "#", formValues === null || formValues === void 0 ? void 0 : formValues.Dealercode))
                                };
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'Branch:',
                            label: 'Branch:',
                            value: null,
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1,
                                spacing: 0
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'Chassis number',
                            label: 'Chassis number:',
                            value: null,
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1,
                                spacing: 0
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'Engine number',
                            label: 'Engine number:',
                            value: null,
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1,
                                spacing: 0
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'Prod. month',
                            label: 'Prod. month:',
                            value: null,
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1,
                                spacing: 0
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'PartName',
                            label: 'Part name & code:',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1,
                                spacing: 0
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12,
                            setFieldProps: function (formValues, currValue, field) {
                                return {
                                    type: FormItemTypes.Typography,
                                    value: /*#__PURE__*/ React.createElement(Box, {
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center"
                                    }, /*#__PURE__*/ React.createElement(Typography, null, formValues === null || formValues === void 0 ? void 0 : formValues.partName), /*#__PURE__*/ React.createElement(Typography, null, formValues === null || formValues === void 0 ? void 0 : formValues.partCode))
                                };
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'defect',
                            label: 'Defect description & code:',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1,
                                spacing: 0
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12,
                            setFieldProps: function (formValues, currValue, field) {
                                return {
                                    type: FormItemTypes.Typography,
                                    value: /*#__PURE__*/ React.createElement(Stack, null, " ", /*#__PURE__*/ React.createElement(Typography, {
                                        fontSize: 'sm',
                                        fontWeight: 'medium'
                                    }, formValues === null || formValues === void 0 ? void 0 : formValues.defectDescription), " ", /*#__PURE__*/ React.createElement(Typography, {
                                        textAlign: 'end',
                                        fontSize: 'sm',
                                        fontWeight: 'medium',
                                        color: 'text.secondary'
                                    }, "#", formValues === null || formValues === void 0 ? void 0 : formValues.defectCode))
                                };
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'KM reading',
                            label: 'KM reading:',
                            value: null,
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1,
                                spacing: 0
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'Repair type',
                            label: 'Repair type:',
                            value: null,
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1,
                                spacing: 0
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'Sale date',
                            label: 'Sale date:',
                            value: null,
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1,
                                spacing: 0
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'JC open date',
                            label: 'JC open date:',
                            value: null,
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1,
                                spacing: 0
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'Plant name & code:',
                            label: 'Plant name & code:',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1,
                                spacing: 0
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12,
                            setFieldProps: function (formValues, currValue, field) {
                                return {
                                    type: FormItemTypes.Typography,
                                    value: /*#__PURE__*/ React.createElement(Stack, null, " ", /*#__PURE__*/ React.createElement(Typography, {
                                        fontSize: 'sm',
                                        fontWeight: 'medium'
                                    }, formValues === null || formValues === void 0 ? void 0 : formValues.PlantName), " ", /*#__PURE__*/ React.createElement(Typography, {
                                        textAlign: 'end',
                                        fontSize: 'sm',
                                        fontWeight: 'medium',
                                        color: 'text.secondary'
                                    }, "#", formValues === null || formValues === void 0 ? void 0 : formValues.PlantCode))
                                };
                            }
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    justifyContent: 'end',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: '',
                            variant: 'outlined',
                            children: 'View FFR',
                            color: 'primary',
                            columnSize: 0
                        }]
                }]
        }];
    var stateWisefailuresReporte = [{
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            containerProps: {
                m: 0,
                mb: 1.5,
                spacing: 0
            },
            sx: {
                padding: '12px'
            },
            contentProps: {
                spacing: 0,
                p: 0,
                rowGap: '12px'
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    p: 0,
                    rowGap: '4px',
                    // sx: {
                    //     bgcolor: 'secondary.50',
                    //     borderRadius: '8px',
                    // },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            value: 'Gujarat',
                            // label: 'Gujarat',
                            columnSize: 12,
                            fontWeight: 'medium'
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'Intensity:',
                            label: 'Intensity :',
                            value: 1,
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'end',
                                alignItems: 'baseline',
                                gap: 1,
                                spacing: 0
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'No of FR’s:',
                            label: 'No of FR’s:',
                            value: 1,
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'end',
                                alignItems: 'baseline',
                                gap: 1,
                                spacing: 0
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12
                        }]
                }]
        }];
    var Genral_Tab = [{
            type: FormItemTypes.Accordian,
            name: 'BasicDetails',
            columnSize: 12,
            value: false,
            summaryProps: {
                sx: {
                    display: "flex",
                    alignItems: "flex-start",
                    position: "relative",
                    paddingTop: 2
                }
            },
            sx: {
                border: '1px',
                borderRadius: "12px",
                borderColor: "#DEE4EB"
            },
            setFormState: function (formValues, currValue) {
                setIsOpen(currValue);
                return {};
            },
            summary: [{
                    type: FormItemTypes.Typography,
                    name: "Basic Details",
                    children: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                        fontSize: "14px",
                        fontWeight: "600",
                        pt: 0
                    }, "Basic details"), !isOpen && /*#__PURE__*/ React.createElement(CardSummury, {
                        hideJCDetails: true
                    })),
                    fontSize: "md",
                    columnSize: 12,
                    fontWeight: "strong"
                }],
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    columnSize: 12,
                    sx: {
                        p: 2
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 0,
                            children: /*#__PURE__*/ React.createElement(BasicDetailcards, {
                                hideJCDetails: true
                            }),
                            fontSize: 'lg',
                            fontWeight: 'strong'
                        }]
                }]
        }, {
            type: FormItemTypes.CardComponent,
            name: '',
            label: 'Vehicle details',
            containerProps: {
                spacing: 0
            },
            columnSize: 12,
            contentProps: {
                spacing: 0
            },
            elements: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    label: '',
                    children: 'Referrence values',
                    columnSize: 12,
                    sx: {
                        display: 'flex',
                        justifyContent: 'flex-end',
                        position: 'relative',
                        top: -30,
                        right: 1
                    },
                    color: 'primary.500'
                }, {
                    type: FormItemTypes.CardComponent,
                    name: '',
                    columnSize: 12,
                    containerProps: {
                        m: 0
                    },
                    sx: {
                        padding: '12px 16px',
                        bgcolor: 'secondary.50',
                        border: 'none'
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Group code & name',
                            children: /*#__PURE__*/ React.createElement(Stack, {
                                direction: 'row'
                            }, " ", /*#__PURE__*/ React.createElement(Typography, {
                                fontSize: 'sm'
                            }, "#FFRGR-782773"), /*#__PURE__*/ React.createElement(Typography, {
                                fontSize: 'sm',
                                color: 'secondary.200'
                            }, "|"), /*#__PURE__*/ React.createElement(Typography, {
                                fontSize: 'sm'
                            }, "C (MC)")),
                            xs: 12,
                            sm: 6,
                            containerProps: {
                                sx: {
                                    display: {
                                        xs: 'inline-flex',
                                        sm: 'block'
                                    }
                                },
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontSize: 'sm',
                            fontWeight: 'medium'
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'First field report date',
                            children: '21 Aug, 2002',
                            xs: 12,
                            sm: 6,
                            containerProps: {
                                sx: {
                                    display: {
                                        xs: 'inline-flex',
                                        sm: 'block'
                                    }
                                },
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontSize: 'sm',
                            fontWeight: 'medium'
                            // textOverflow: 'ellipsis',
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'No. of parts dispatched to CQA',
                            children: '1',
                            xs: 12,
                            sm: 6,
                            containerProps: {
                                sx: {
                                    display: {
                                        xs: 'inline-flex',
                                        sm: 'block'
                                    }
                                },
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                textOverflow: 'unset',
                                whiteSpace: 'wrap'
                            },
                            fontSize: 'sm',
                            fontWeight: 'medium',
                            sx: {
                                // whiteSpace: 'nowrap',
                                // overflow: 'hidden',
                                // textOverflow: 'ellipsis',
                                textAlign: {
                                    xs: 'end',
                                    sm: 'start'
                                }
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'First CQA information date',
                            children: '6 Aug, 2025',
                            xs: 12,
                            sm: 6,
                            containerProps: {
                                sx: {
                                    display: {
                                        xs: 'inline-flex',
                                        sm: 'block'
                                    }
                                },
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                textOverflow: 'unset',
                                whiteSpace: 'wrap'
                            },
                            sx: {
                                // whiteSpace: 'nowrap',
                                // overflow: 'hidden',
                                // textOverflow: 'ellipsis',
                                textAlign: {
                                    xs: 'end',
                                    sm: 'start'
                                }
                            },
                            fontSize: 'sm',
                            fontWeight: 'medium'
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Customer voice ',
                            children: 'A little about the company and the team that you’ll be working with.',
                            xs: 12,
                            sm: 6,
                            containerProps: {
                                sx: {
                                    display: {
                                        xs: 'inline-flex',
                                        sm: 'block'
                                    }
                                },
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                textOverflow: 'unset',
                                whiteSpace: 'wrap'
                            },
                            sx: {
                                // whiteSpace: 'nowrap',
                                // overflow: 'hidden',
                                // textOverflow: 'ellipsis',
                                textAlign: {
                                    xs: 'end',
                                    sm: 'start'
                                }
                            },
                            fontSize: 'sm',
                            fontWeight: 'medium'
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Defect phenomenon',
                            children: 'A little about the company and the team that you’ll be working with.',
                            xs: 12,
                            sm: 6,
                            containerProps: {
                                sx: {
                                    display: {
                                        xs: 'inline-flex',
                                        sm: 'block'
                                    }
                                },
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                textOverflow: 'unset',
                                whiteSpace: 'wrap'
                            },
                            sx: {
                                // whiteSpace: 'nowrap',
                                // overflow: 'hidden',
                                // textOverflow: 'ellipsis',
                                textAlign: {
                                    xs: 'end',
                                    sm: 'start'
                                }
                            },
                            fontSize: 'sm',
                            fontWeight: 'medium'
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Root cause :',
                            children: 'A little about the company and the team that you’ll be working with.',
                            xs: 12,
                            sm: 6,
                            containerProps: {
                                sx: {
                                    display: {
                                        xs: 'inline-flex',
                                        sm: 'block'
                                    }
                                },
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                textOverflow: 'unset',
                                whiteSpace: 'wrap'
                            },
                            sx: {
                                // whiteSpace: 'nowrap',
                                // overflow: 'hidden',
                                // textOverflow: 'ellipsis',
                                textAlign: {
                                    xs: 'end',
                                    sm: 'start'
                                }
                            },
                            fontSize: 'sm',
                            fontWeight: 'medium'
                        }]
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: '',
                    label: 'Type of failure',
                    required: true,
                    options: [],
                    // columnSize: 4,
                    xs: 12,
                    labelTypographyProps: {
                        pt: 1.5
                    }
                }]
        }, {
            type: FormItemTypes.CardComponent,
            name: '',
            label: 'Defective part details',
            containerProps: {
                spacing: 0
            },
            columnSize: 12,
            contentProps: {
                spacing: 0,
                gap: '20px'
            },
            elements: [{
                    type: FormItemTypes.CardComponent,
                    name: '',
                    columnSize: 12,
                    containerProps: {
                        m: 0
                    },
                    sx: {
                        padding: '12px 16px',
                        bgcolor: 'secondary.50',
                        border: 'none'
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Main defective part',
                            children: /*#__PURE__*/ React.createElement(Stack, {
                                direction: 'row'
                            }, " ", /*#__PURE__*/ React.createElement(Typography, {
                                fontSize: 'sm'
                            }, "JL 131232"), /*#__PURE__*/ React.createElement(Typography, {
                                fontSize: 'sm',
                                color: 'secondary.200'
                            }, "|"), /*#__PURE__*/ React.createElement(Typography, {
                                fontSize: 'sm'
                            }, "Damper coupling")),
                            xs: 12,
                            sm: 6,
                            containerProps: {
                                sx: {
                                    display: {
                                        xs: 'inline-flex',
                                        sm: 'block'
                                    }
                                },
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontSize: 'sm',
                            fontWeight: 'medium'
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Vendor name',
                            children: 'BM Rushikesh',
                            xs: 12,
                            sm: 6,
                            containerProps: {
                                sx: {
                                    display: {
                                        xs: 'inline-flex',
                                        sm: 'block'
                                    }
                                },
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                textOverflow: 'unset',
                                whiteSpace: 'wrap'
                            },
                            sx: {
                                // whiteSpace: 'nowrap',
                                // overflow: 'hidden',
                                // textOverflow: 'ellipsis',
                                textAlign: {
                                    xs: 'end',
                                    sm: 'start'
                                }
                            },
                            fontSize: 'sm',
                            fontWeight: 'medium'
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Manufacturing date',
                            children: '21 Aug, 2002',
                            xs: 12,
                            sm: 6,
                            containerProps: {
                                sx: {
                                    display: {
                                        xs: 'inline-flex',
                                        sm: 'block'
                                    }
                                },
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                textOverflow: 'unset',
                                whiteSpace: 'wrap'
                            },
                            sx: {
                                // whiteSpace: 'nowrap',
                                // overflow: 'hidden',
                                // textOverflow: 'ellipsis',
                                textAlign: {
                                    xs: 'end',
                                    sm: 'start'
                                }
                            },
                            fontSize: 'sm',
                            fontWeight: 'medium'
                        }]
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'Category',
                    label: 'Category',
                    required: true,
                    xs: 12,
                    sm: 6,
                    md: 6
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'Priority',
                    label: 'Priority',
                    required: true,
                    xs: 12,
                    sm: 5.5,
                    md: 5.5
                }]
        }, {
            type: FormItemTypes.CardComponent,
            name: '',
            // label: 'State wise failures reported',
            containerProps: {
                spacing: 0
            },
            columnSize: 12,
            contentProps: {
                spacing: 0,
                padding: 0
            },
            sx: {
                padding: 0
            },
            elements: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    children: 'State wise failures reported',
                    columnSize: 12,
                    sx: {
                        padding: '12px 16px',
                        fontWeight: 'strong'
                    }
                }, isMobile ? {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    spacing: 0,
                    p: 1.5,
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.Iterator,
                            name: '',
                            columnSize: 12,
                            containerProps: {
                                container: true,
                                spacing: 2
                            },
                            gridItemProps: {
                                xs: 12,
                                sm: 12,
                                md: 12,
                                lg: 12
                            },
                            value: [{
                                    id: 1
                                }, {
                                    id: 2
                                }],
                            elements: stateWisefailuresReporte
                        }]
                } : {
                    type: FormItemTypes.Custom,
                    name: '',
                    columnSize: 12,
                    element: CQAFailFailureReportsCatlog
                }]
        }];
    var Problem_description_OR_change_sequence = [{
            type: FormItemTypes.CardComponent,
            name: '',
            containerProps: {
                spacing: 0
            },
            columnSize: 12,
            contentProps: {
                spacing: 0,
                gap: '20px'
            },
            elements: [{
                    type: FormItemTypes.CardComponent,
                    name: '',
                    columnSize: 12,
                    containerProps: {
                        m: 0
                    },
                    sx: {
                        padding: '12px 16px',
                        bgcolor: 'secondary.50',
                        border: 'none'
                    },
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            xs: 12,
                            sm: 12,
                            md: 6,
                            lg: 6,
                            spacing: 0,
                            justifyContent: 'end',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    label: 'Why? Cause of Failure Observed During Repair',
                                    children: 'A little about the company and the team that you’ll be working with.',
                                    columnSize: true,
                                    labelTypographyProps: {
                                        m: 0
                                    },
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    sx: {
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                    }
                                }, {
                                    type: FormItemTypes.Button,
                                    name: '',
                                    variant: 'text',
                                    size: 'small',
                                    color: 'primary',
                                    children: 'Reference values',
                                    columnSize: 0,
                                    onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                        var data, res, _a;
                                        return __generator(this, function (_b) {
                                            switch (_b.label) {
                                                case 0:
                                                    data = {
                                                        Title: 'Why? Cause of Failure Observed During Repair(Reference values)',
                                                        ReferanceValueData: [{
                                                                id: 1,
                                                                ActionsTaken: 'A little about the company and the team that you’ll be working with.',
                                                                AFRnumber: 'AFR-9883992'
                                                            }, {
                                                                id: 2,
                                                                ActionsTaken: 'A little about the company and the team that you’ll be working with.',
                                                                AFRnumber: 'AFR-9883992'
                                                            }],
                                                        columns: [{
                                                                type: 'string',
                                                                field: 'AFRnumber',
                                                                headerName: 'AFR number',
                                                                minWidth: 150
                                                            }, {
                                                                field: 'ActionsTaken',
                                                                headerName: 'Why? Cause of Failure Observed During Repair',
                                                                flex: 1
                                                            }]
                                                    };
                                                    if (!isMobile) return [3 /*break*/, 2];
                                                    return [4 /*yield*/, dispatch(showSurface({
                                                            type: 'Drawer',
                                                            Component: CQAAcceptReferenceValuePopUp,
                                                            componentProps: {
                                                                data: data
                                                            },
                                                            containerProps: {
                                                                anchor: 'bottom',
                                                                PaperProps: {
                                                                    sx: {
                                                                        borderRadius: {
                                                                            xs: '12px 12px 0 0'
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }))];
                                                case 1:
                                                    _a = _b.sent();
                                                    return [3 /*break*/, 4];
                                                case 2: return [4 /*yield*/, dispatch(showSurface({
                                                        type: 'Dialog',
                                                        Component: CQAAcceptReferenceValuePopUp,
                                                        componentProps: {
                                                            data: data
                                                        }
                                                    }))];
                                                case 3:
                                                    _a = _b.sent();
                                                    _b.label = 4;
                                                case 4:
                                                    res = _a;
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); },
                                    sx: {
                                        p: 0
                                    }
                                }]
                        }, {
                            type: FormItemTypes.Divider,
                            name: 'name',
                            variant: 'fullWidth',
                            columnSize: 12,
                            containerProps: {
                                sx: {
                                    display: {
                                        sm: 'none'
                                    }
                                }
                            }
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            xs: 12,
                            sm: 12,
                            md: 6,
                            lg: 6,
                            spacing: 0,
                            justifyContent: 'end',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    label: 'How? How You Identified Defective Part?',
                                    children: 'A little about the company and the team that you’ll be working with.',
                                    columnSize: true,
                                    labelTypographyProps: {
                                        m: 0
                                    },
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    sx: {
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                    }
                                }, {
                                    type: FormItemTypes.Button,
                                    name: '',
                                    variant: 'text',
                                    size: 'small',
                                    color: 'primary',
                                    children: 'Reference values',
                                    columnSize: 0,
                                    onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                        var data, res, _a;
                                        return __generator(this, function (_b) {
                                            switch (_b.label) {
                                                case 0:
                                                    data = {
                                                        Title: 'How? How You Identified Defective Part?(Reference values)',
                                                        ReferanceValueData: [{
                                                                id: 1,
                                                                ActionsTaken: 'A little about the company and the team that you’ll be working with.',
                                                                AFRnumber: 'AFR-9883992'
                                                            }, {
                                                                id: 2,
                                                                ActionsTaken: 'A little about the company and the team that you’ll be working with.',
                                                                AFRnumber: 'AFR-9883992'
                                                            }],
                                                        columns: [{
                                                                type: 'string',
                                                                field: 'AFRnumber',
                                                                headerName: 'AFR number',
                                                                minWidth: 150
                                                            }, {
                                                                field: 'ActionsTaken',
                                                                headerName: 'How? How You Identified Defective Part?d',
                                                                flex: 1
                                                            }]
                                                    };
                                                    if (!isMobile) return [3 /*break*/, 2];
                                                    return [4 /*yield*/, dispatch(showSurface({
                                                            type: 'Drawer',
                                                            Component: CQAAcceptReferenceValuePopUp,
                                                            componentProps: {
                                                                data: data
                                                            },
                                                            containerProps: {
                                                                anchor: 'bottom',
                                                                PaperProps: {
                                                                    sx: {
                                                                        borderRadius: {
                                                                            xs: '12px 12px 0 0'
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }))];
                                                case 1:
                                                    _a = _b.sent();
                                                    return [3 /*break*/, 4];
                                                case 2: return [4 /*yield*/, dispatch(showSurface({
                                                        type: 'Dialog',
                                                        Component: CQAAcceptReferenceValuePopUp,
                                                        componentProps: {
                                                            data: data
                                                        }
                                                    }))];
                                                case 3:
                                                    _a = _b.sent();
                                                    _b.label = 4;
                                                case 4:
                                                    res = _a;
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); },
                                    sx: {
                                        p: 0
                                    }
                                }]
                        }, {
                            type: FormItemTypes.Divider,
                            name: 'name',
                            variant: 'fullWidth',
                            columnSize: 12,
                            containerProps: {
                                sx: {
                                    display: {
                                        sm: 'none'
                                    }
                                }
                            }
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            xs: 12,
                            sm: 12,
                            md: 6,
                            lg: 6,
                            spacing: 0,
                            justifyContent: 'end',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    label: 'Temporary Actions Taken in Field',
                                    children: 'A little about the company and the team that you’ll be working with.',
                                    columnSize: true,
                                    labelTypographyProps: {
                                        m: 0
                                    },
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    sx: {
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                    }
                                }, {
                                    type: FormItemTypes.Button,
                                    name: '',
                                    variant: 'text',
                                    size: 'small',
                                    color: 'primary',
                                    children: 'Reference values',
                                    columnSize: 0,
                                    onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                        var data, res, _a;
                                        return __generator(this, function (_b) {
                                            switch (_b.label) {
                                                case 0:
                                                    data = {
                                                        Title: 'Temporary Actions Taken in Field (Reference values)',
                                                        ReferanceValueData: [{
                                                                id: 1,
                                                                ActionsTaken: 'A little about the company and the team that you’ll be working with.',
                                                                AFRnumber: 'AFR-9883992'
                                                            }, {
                                                                id: 2,
                                                                ActionsTaken: 'A little about the company and the team that you’ll be working with.',
                                                                AFRnumber: 'AFR-9883992'
                                                            }],
                                                        columns: [{
                                                                type: 'string',
                                                                field: 'AFRnumber',
                                                                headerName: 'AFR number',
                                                                minWidth: 150
                                                            }, {
                                                                field: 'ActionsTaken',
                                                                headerName: 'Temporary Actions Taken in Field',
                                                                flex: 1
                                                            }]
                                                    };
                                                    if (!isMobile) return [3 /*break*/, 2];
                                                    return [4 /*yield*/, dispatch(showSurface({
                                                            type: 'Drawer',
                                                            Component: CQAAcceptReferenceValuePopUp,
                                                            componentProps: {
                                                                data: data
                                                            },
                                                            containerProps: {
                                                                anchor: 'bottom',
                                                                PaperProps: {
                                                                    sx: {
                                                                        borderRadius: {
                                                                            xs: '12px 12px 0 0'
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }))];
                                                case 1:
                                                    _a = _b.sent();
                                                    return [3 /*break*/, 4];
                                                case 2: return [4 /*yield*/, dispatch(showSurface({
                                                        type: 'Dialog',
                                                        Component: CQAAcceptReferenceValuePopUp,
                                                        componentProps: {
                                                            data: data
                                                        }
                                                    }))];
                                                case 3:
                                                    _a = _b.sent();
                                                    _b.label = 4;
                                                case 4:
                                                    res = _a;
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); },
                                    sx: {
                                        p: 0
                                    }
                                }]
                        }, {
                            type: FormItemTypes.Divider,
                            name: 'name',
                            variant: 'fullWidth',
                            columnSize: 12,
                            containerProps: {
                                sx: {
                                    display: {
                                        sm: 'none'
                                    }
                                }
                            }
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            xs: 12,
                            sm: 12,
                            md: 6,
                            lg: 6,
                            spacing: 0,
                            justifyContent: 'end',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    label: 'Parameters checked',
                                    children: 'A little about the company and the team that you’ll be working with.',
                                    columnSize: true,
                                    labelTypographyProps: {
                                        m: 0
                                    },
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    sx: {
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                    }
                                }, {
                                    type: FormItemTypes.Button,
                                    name: '',
                                    variant: 'text',
                                    size: 'small',
                                    color: 'primary',
                                    children: 'Reference values',
                                    columnSize: 0,
                                    onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                        var data, _a;
                                        return __generator(this, function (_b) {
                                            switch (_b.label) {
                                                case 0:
                                                    data = {
                                                        Title: 'Temporary Actions Taken in Field (Reference values)',
                                                        ReferanceValueData: [{
                                                                id: 1,
                                                                ActionsTaken: 'A little about the company and the team that you’ll be working with.',
                                                                AFRnumber: 'AFR-9883992'
                                                            }, {
                                                                id: 2,
                                                                ActionsTaken: 'A little about the company and the team that you’ll be working with.',
                                                                AFRnumber: 'AFR-9883992'
                                                            }],
                                                        columns: [{
                                                                type: 'string',
                                                                field: 'AFRnumber',
                                                                headerName: 'AFR number',
                                                                minWidth: 150
                                                            }, {
                                                                field: 'ActionsTaken',
                                                                headerName: 'Temporary Actions Taken in Field',
                                                                flex: 1
                                                            }]
                                                    };
                                                    if (!isMobile) return [3 /*break*/, 2];
                                                    return [4 /*yield*/, dispatch(showSurface({
                                                            type: 'Drawer',
                                                            Component: CQAAcceptReferenceValuePopUp,
                                                            componentProps: {
                                                                data: data
                                                            },
                                                            containerProps: {
                                                                anchor: 'bottom',
                                                                PaperProps: {
                                                                    sx: {
                                                                        borderRadius: {
                                                                            xs: '12px 12px 0 0'
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }))];
                                                case 1:
                                                    _a = _b.sent();
                                                    return [3 /*break*/, 4];
                                                case 2: return [4 /*yield*/, dispatch(showSurface({
                                                        type: 'Dialog',
                                                        Component: CQAAcceptReferenceValuePopUp,
                                                        componentProps: {
                                                            data: {
                                                                Title: 'Parameters checked',
                                                                ReferanceValueData: [{
                                                                        id: 1,
                                                                        ActionsTaken: 'A little about the company and the team that you’ll be working with.',
                                                                        Parameterafter: 'A little about the company and the team that you’ll be working with.',
                                                                        Observationbefore: 'A little about the company and the team that you’ll be working with.',
                                                                        Observationafter: 'A little about the company and the team that you’ll be working with.',
                                                                        FFRnumber: 'FFR-9883992'
                                                                    }, {
                                                                        id: 2,
                                                                        ActionsTaken: 'A little about the company and the team that you’ll be working with.',
                                                                        Parameterafter: 'A little about the company and the team that you’ll be working with.',
                                                                        Observationbefore: 'A little about the company and the team that you’ll be working with.',
                                                                        Observationafter: 'A little about the company and the team that you’ll be working with.',
                                                                        FFRnumber: 'FFR-9883992'
                                                                    }],
                                                                columns: [{
                                                                        type: 'string',
                                                                        field: 'FFRnumber',
                                                                        headerName: 'FFR number',
                                                                        minWidth: 150
                                                                    }, {
                                                                        field: 'ActionsTaken',
                                                                        headerName: 'Parameter before repair',
                                                                        minWidth: 150
                                                                    }, {
                                                                        field: 'Parameterafter',
                                                                        headerName: 'Parameter after repair',
                                                                        minWidth: 150
                                                                    }, {
                                                                        field: 'Observationbefore',
                                                                        headerName: 'Observation before repair',
                                                                        minWidth: 150
                                                                    }, {
                                                                        field: 'Observationafter',
                                                                        headerName: 'Observation after repair',
                                                                        minWidth: 150
                                                                    }]
                                                            }
                                                        }
                                                    }))];
                                                case 3:
                                                    _a = _b.sent();
                                                    _b.label = 4;
                                                case 4:
                                                    _a;
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); },
                                    // onClick: async () => {
                                    //     const data = {
                                    //         Title: 'Temporary Actions Taken in Field (Reference values)',
                                    //         ReferanceValueData: [
                                    //             { id: 1, ActionsTaken: 'A little about the company and the team that you’ll be working with.', AFRnumber: 'AFR-9883992' },
                                    //             { id: 2, ActionsTaken: 'A little about the company and the team that you’ll be working with.', AFRnumber: 'AFR-9883992' }
                                    //         ],
                                    //         columns: [
                                    //             {
                                    //                 type: 'string',
                                    //                 field: 'AFRnumber',
                                    //                 headerName: 'AFR number',
                                    //                 minWidth: 150,
                                    //             },
                                    //             {
                                    //                 field: 'ActionsTaken',
                                    //                 headerName: 'Temporary Actions Taken in Field',
                                    //                 flex: 1
                                    //             },
                                    //         ]
                                    //     }
                                    //     const res = isMobile ?
                                    //         await dispatch(showSurface({
                                    //             type: 'Drawer',
                                    //             Component: CQAAcceptReferenceValuePopUp,
                                    //             componentProps: {
                                    //                 data: data
                                    //             },
                                    //             containerProps: {
                                    //                 anchor: 'bottom',
                                    //                 PaperProps: {
                                    //                     sx: {
                                    //                         borderRadius: {
                                    //                             xs: '12px 12px 0 0'
                                    //                         }
                                    //                     }
                                    //                 }
                                    //             }
                                    //         })) :
                                    //         await dispatch(showSurface({
                                    //             type: 'Dialog',
                                    //             Component: CQAAcceptReferenceValuePopUp,
                                    //             componentProps: {
                                    //                 data: data
                                    //             },
                                    //         }))
                                    // },
                                    sx: {
                                        p: 0
                                    }
                                }]
                        }]
                }]
        }, {
            type: FormItemTypes.CardComponent,
            name: '',
            containerProps: {
                spacing: 0
            },
            columnSize: 12,
            contentProps: {
                spacing: 0,
                gap: '20px'
            },
            elements: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    children: 'Which parameter checked while doing repair?',
                    fontWeight: 'strong',
                    columnSize: true
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'text',
                    size: 'small',
                    color: 'primary',
                    children: 'Reference values',
                    columnSize: 0,
                    sx: {
                        p: 0
                    },
                    onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var data, _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    data = {
                                        Title: 'Parameters checked',
                                        ReferanceValueData: [{
                                                id: 1,
                                                ActionsTaken: 'A little about the company and the team that you’ll be working with.',
                                                AFRnumber: 'FFR-9883992'
                                            }, {
                                                id: 2,
                                                ActionsTaken: 'A little about the company and the team that you’ll be working with.',
                                                AFRnumber: 'FFR-9883992'
                                            }],
                                        columns: [{
                                                type: 'string',
                                                field: 'AFRnumber',
                                                headerName: 'AFR number',
                                                minWidth: 150
                                            }, {
                                                field: 'ActionsTaken',
                                                headerName: 'Temporary Actions Taken in Field',
                                                flex: 1
                                            }]
                                    };
                                    if (!isMobile) return [3 /*break*/, 2];
                                    return [4 /*yield*/, dispatch(showSurface({
                                            type: 'Drawer',
                                            Component: CustomerComplaintMobileView,
                                            componentProps: {
                                                data: data
                                            },
                                            containerProps: {
                                                anchor: 'bottom',
                                                PaperProps: {
                                                    sx: {
                                                        borderRadius: {
                                                            xs: '12px 12px 0 0'
                                                        }
                                                    }
                                                }
                                            }
                                        }))];
                                case 1:
                                    _a = _b.sent();
                                    return [3 /*break*/, 4];
                                case 2: return [4 /*yield*/, dispatch(showSurface({
                                        type: 'Dialog',
                                        Component: RefernceValuepopup,
                                        componentProps: {
                                            data: {
                                                Title: 'Customer complaints (Reference values)',
                                                ReferanceValueData: [{
                                                        id: 1,
                                                        ActionsTaken: 'Both',
                                                        FFRnumber: 'AFR-9883992',
                                                        problem: 'A little about the company and the team that you’ll be working with.',
                                                        where: 'All road',
                                                        vehicleSpeed: '90 kms'
                                                    }, {
                                                        id: 2,
                                                        ActionsTaken: 'Hot',
                                                        FFRnumber: 'AFR-9883992',
                                                        problem: 'A little about the company and the team that you’ll be working with.',
                                                        where: 'All road',
                                                        vehicleSpeed: '90 kms'
                                                    }],
                                                columns: [{
                                                        type: 'string',
                                                        field: 'FFRnumber',
                                                        headerName: 'FFR number',
                                                        minWidth: 120
                                                    }, {
                                                        field: 'ActionsTaken',
                                                        headerName: 'When',
                                                        flex: 120
                                                    }, {
                                                        field: 'problem',
                                                        headerName: 'What (Problem Description)',
                                                        flex: 200
                                                    }, {
                                                        field: 'where',
                                                        headerName: 'Whare',
                                                        flex: 200
                                                    }, {
                                                        field: 'vehicleSpeed',
                                                        headerName: 'Vehicle speed',
                                                        flex: 200
                                                    }]
                                            }
                                        }
                                    }))];
                                case 3:
                                    _a = _b.sent();
                                    _b.label = 4;
                                case 4:
                                    _a;
                                    return [2 /*return*/];
                            }
                        });
                    }); }
                }, {
                    type: FormItemTypes.CardComponent,
                    name: '',
                    columnSize: 12,
                    containerProps: {
                        m: 0
                    },
                    sx: {
                        padding: '12px 16px',
                        bgcolor: 'secondary.50',
                        border: 'none'
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'What (Problem Description)',
                            children: 'A little about the company and the team that you’ll be working with.',
                            xs: 12,
                            sm: 6,
                            md: 6,
                            lg: 6,
                            labelTypographyProps: {
                                m: 0
                            },
                            fontSize: 'sm',
                            fontWeight: 'medium',
                            sx: {
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }
                        }, {
                            type: FormItemTypes.Divider,
                            name: 'name',
                            variant: 'fullWidth',
                            columnSize: 12,
                            containerProps: {
                                sx: {
                                    display: {
                                        sm: 'none'
                                    }
                                }
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Where (Road Condition)',
                            children: 'A little about the company and the team that you’ll be working with.',
                            xs: 12,
                            sm: 6,
                            md: 6,
                            lg: 6,
                            labelTypographyProps: {
                                m: 0
                            },
                            fontSize: 'sm',
                            fontWeight: 'medium',
                            sx: {
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }
                        }, {
                            type: FormItemTypes.Divider,
                            name: 'name',
                            variant: 'fullWidth',
                            columnSize: 12,
                            containerProps: {
                                sx: {
                                    display: {
                                        sm: 'none'
                                    }
                                }
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'When',
                            children: 'Cold',
                            xs: 12,
                            sm: 6,
                            md: 6,
                            lg: 6,
                            labelTypographyProps: {
                                m: 0
                            },
                            fontSize: 'sm',
                            fontWeight: 'medium',
                            sx: {
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }
                        }, {
                            type: FormItemTypes.Divider,
                            name: 'name',
                            variant: 'fullWidth',
                            columnSize: 12,
                            containerProps: {
                                sx: {
                                    display: {
                                        sm: 'none'
                                    }
                                }
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Vehicle speed (Km/Hr)',
                            children: '70 kms',
                            xs: 12,
                            sm: 6,
                            md: 6,
                            lg: 6,
                            labelTypographyProps: {
                                m: 0
                            },
                            fontSize: 'sm',
                            fontWeight: 'medium',
                            sx: {
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }
                        }]
                }]
        },
        // {
        //     type: FormItemTypes.CardComponent,
        //     name: '',
        //     label: 'Failed component attachment',
        //     containerProps: {
        //         spacing: 0,
        //     },
        //     columnSize: 12,
        //     contentProps: {
        //         spacing: 2,
        //     },
        //     elements: Array.from({ length: 4 }).map((_, index) => {
        //         return {
        //             type: FormItemTypes.CardComponent,
        //             name: '',
        //             xs: 12,
        //             sm: 12,
        //             md: 6,
        //             lg: 6,
        //             containerProps: {
        //                 m: 0,
        //             },
        //             sx: {
        //                 padding: '12px 16px',
        //             },
        //             elements: [
        //                 {
        //                     type: FormItemTypes.Avatar,
        //                     name: '',
        //                     columnSize: 0,
        //                     variant: 'square',
        //                     sx: {
        //                         height: '100%',
        //                         width: '64px'
        //                     }
        //                 },
        //                 {
        //                     type: FormItemTypes.ContainerItem,
        //                     name: '',
        //                     columnSize: 9.8,
        //                     spacing: 0,
        //                     gap: '10px',
        //                     elements: [
        //                         {
        //                             type: FormItemTypes.Typography,
        //                             name: '',
        //                             label: 'Invoice - Jobcard #12345678.pdf',
        //                             children: '200 KB',
        //                             columnSize: true,
        //                             color: 'secondary.500',
        //                             labelTypographyProps: {
        //                                 m: 0,
        //                                 color: 'text.primary',
        //                                 fontSize: 'base'
        //                             },
        //                         },
        //                         {
        //                             type: FormItemTypes.Chip,
        //                             name: '',
        //                             label: 'A little about the company and the team that you’ll be working with.',
        //                             columnSize: true,
        //                             color: 'secondary',
        //                             shape: 'rounded',
        //                             sx: {
        //                                 fontSize: 'base',
        //                                 fontWeight: 'normal'
        //                             }
        //                         },
        //                     ],
        //                 }
        //             ]
        //         };
        //     }),
        // },
        {
            type: FormItemTypes.CardComponent,
            name: '',
            containerProps: {
                spacing: 0
            },
            columnSize: 12,
            contentProps: {
                spacing: 2
            },
            elements: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    children: 'Failed component attachment',
                    fontWeight: 'strong',
                    columnSize: true
                }, {
                    type: FormItemTypes.Attachment,
                    name: 'Attachments',
                    placeholder: 'Upload',
                    disabled: false,
                    value: null,
                    columnSize: 0,
                    inputProps: {
                        accept: 'application/*',
                        multiple: true
                    },
                    uploadButtonProps: {
                        variant: 'text',
                        color: 'primary'
                    },
                    attachmentButtonProps: {
                        sx: {
                            display: 'none'
                        }
                    }
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    rowGap: 2,
                    columnSpacing: 2,
                    elements: Array.from({
                        length: 4
                    }).map(function (_, index) {
                        return {
                            type: FormItemTypes.CardComponent,
                            name: '',
                            xs: 12,
                            sm: 12,
                            md: 6,
                            lg: 6,
                            containerProps: {
                                m: 0,
                                spacing: 0
                            },
                            sx: {
                                padding: '12px 16px'
                            },
                            contentProps: {
                                spacing: 2
                            },
                            elements: [{
                                    type: FormItemTypes.Avatar,
                                    name: '',
                                    xs: 4,
                                    sm: 2,
                                    md: 2,
                                    variant: 'square',
                                    containerProps: {
                                        spacing: 0
                                    },
                                    sx: {
                                        height: '100%',
                                        width: '100%'
                                    }
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    // columnSize: 8,
                                    xs: 8,
                                    sm: 10,
                                    md: true,
                                    lg: true,
                                    spacing: 0,
                                    gap: '10px',
                                    elements: [{
                                            type: FormItemTypes.ContainerItem,
                                            name: '',
                                            columnSize: 12,
                                            spacing: 0,
                                            columnGap: '10px',
                                            sx: {
                                                display: 'flex',
                                                justifyContent: 'space-between'
                                            },
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    label: 'Invoice - Jobcard #12345678.pdf',
                                                    children: '200 KB',
                                                    xs: 8,
                                                    sm: 8,
                                                    md: true,
                                                    lg: true,
                                                    color: 'secondary.500',
                                                    labelTypographyProps: {
                                                        m: 0,
                                                        color: 'text.primary',
                                                        fontSize: 'base',
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis'
                                                    }
                                                },
                                                // {
                                                //     type: FormItemTypes.IconButton,
                                                //     name: '',
                                                //     children: <Upload fontSize='inherit' color='secondary' />,
                                                //     columnSize: 0,
                                                //     color: 'secondary'
                                                // },
                                                {
                                                    type: FormItemTypes.IconButton,
                                                    name: '',
                                                    children: /*#__PURE__*/ React.createElement(Delete, {
                                                        color: "secondary"
                                                    }),
                                                    columnSize: 0
                                                }]
                                        }, {
                                            type: FormItemTypes.TextInput,
                                            name: 'Remarks',
                                            value: '',
                                            columnSize: 12,
                                            placeholder: 'Enter remarks'
                                        }]
                                }]
                        };
                    })
                }]
        }];
    var History_Tab = [{
            type: FormItemTypes.CardComponent,
            name: '',
            containerProps: {
                spacing: 0
            },
            columnSize: 12,
            contentProps: {
                spacing: 0,
                padding: 0
            },
            sx: {
                padding: 0
            },
            elements: [!isMobile ? {
                    type: FormItemTypes.Typography,
                    name: '',
                    children: 'History',
                    columnSize: 12,
                    sx: {
                        padding: '12px 16px',
                        fontWeight: 'strong'
                    }
                } : null, {
                    type: FormItemTypes.Custom,
                    name: '',
                    columnSize: 12,
                    element: isMobile ? CQAReceivedEditHistoryListViewMobile : CQAHistoryTabReceivedEdit
                }]
        }];
    var Related_documents = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "SelectedButton",
                    value: 'All',
                    columnSize: 12,
                    spacing: 0,
                    columnGap: 1.5,
                    alignItems: "center",
                    py: 2.5,
                    px: 3,
                    elements: [{
                            type: FormItemTypes.CardComponent,
                            name: "",
                            columnSize: 0,
                            sx: {
                                bgcolor: "secondary.100",
                                p: 0.5
                            },
                            contentProps: {
                                spacing: 0,
                                columnGap: 0.5
                            },
                            elements: [{
                                    type: FormItemTypes.Button,
                                    name: "Child AFR",
                                    color: "secondary",
                                    columnSize: 0,
                                    setFormState: function () { return ({
                                        SelectedButton: "Child AFR"
                                    }); },
                                    setFieldProps: function (formValues, currValue) {
                                        return {
                                            type: FormItemTypes.Button,
                                            sx: {
                                                color: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? 'black' : ''
                                            },
                                            children: /*#__PURE__*/ React.createElement(Box, {
                                                display: "flex",
                                                gap: 1,
                                                justifyContent: "space-between",
                                                alignItems: "center"
                                            }, /*#__PURE__*/ React.createElement(Typography, {
                                                fontWeight: 'bold'
                                            }, " ", "Child AFR"), /*#__PURE__*/ React.createElement(Chip, {
                                                label: 11,
                                                size: "small",
                                                variant: "filled",
                                                color: "secondary",
                                                sx: {
                                                    color: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? 'black' : '',
                                                    borderRadius: 6,
                                                    px: 1,
                                                    fontWeight: "bold",
                                                    fontSize: 12
                                                }
                                            })),
                                            variant: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? "outlined" : "text"
                                        };
                                    }
                                }, {
                                    type: FormItemTypes.Button,
                                    name: "Child FFR",
                                    color: "secondary",
                                    columnSize: 0,
                                    setFormState: function () { return ({
                                        SelectedButton: "Child FFR"
                                    }); },
                                    setFieldProps: function (formValues, currValue) {
                                        return {
                                            type: FormItemTypes.Button,
                                            sx: {
                                                color: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? 'black' : ''
                                            },
                                            children: /*#__PURE__*/ React.createElement(Box, {
                                                display: "flex",
                                                gap: 1,
                                                justifyContent: "space-between",
                                                alignItems: "center"
                                            }, /*#__PURE__*/ React.createElement(Typography, {
                                                fontWeight: 'bold'
                                            }, " ", "Child FFR"), /*#__PURE__*/ React.createElement(Chip, {
                                                label: 10,
                                                size: "small",
                                                variant: "filled",
                                                color: "secondary",
                                                sx: {
                                                    color: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? 'black' : '',
                                                    borderRadius: 6,
                                                    px: 1,
                                                    fontWeight: "bold",
                                                    fontSize: 12
                                                }
                                            })),
                                            variant: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? "outlined" : "text"
                                        };
                                    }
                                }]
                        }]
                }]
        }, isMobile ? {
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            onClick: function () { },
            contentProps: {
                spacing: 0.5
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    justifyContent: "space-between",
                    display: "flex",
                    alignItems: 'center',
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 8,
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                            flexDirection: 'column',
                            spacing: 0,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: "DocumentNo",
                                    columnSize: true,
                                    value: '#1234567',
                                    labelTypographyProps: {
                                        fontSize: 'base',
                                        fontWeight: 'medium'
                                    },
                                    fontSize: 'base',
                                    fontWeight: 'medium',
                                    color: systemColor.black
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: "OrderDate",
                                    // valueGetter: (val, row) => (val?.CreatedOn ? `${dateFormate(val?.CreatedOn)}` : '-'),
                                    // label: cardData.docNo,
                                    columnSize: true,
                                    labelTypographyProps: {
                                        fontSize: 'base',
                                        fontWeight: 'medium',
                                        color: '#1B1D21'
                                    },
                                    fontSize: 'sm',
                                    fontWeight: 'normal',
                                    color: systemColor.lightGrey
                                }]
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 4,
                            justifyContent: 'flex-end',
                            alignItems: 'baseline',
                            spacing: 1,
                            elements: [{
                                    type: FormItemTypes.IconButton,
                                    name: "menuIcon",
                                    color: 'secondary',
                                    size: 'small',
                                    children: /*#__PURE__*/ React.createElement(MoreVert, {
                                        color: "secondary"
                                    }),
                                    columnSize: 2,
                                    sx: {
                                        width: '18px',
                                        height: '18px'
                                    }
                                }]
                        }]
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'expanded',
                    value: false,
                    containerProps: {
                        spacing: 0
                    },
                    summaryProps: {
                        sx: {
                            display: 'none'
                        }
                    },
                    summary: [],
                    detailPanelProps: {
                        spacing: 1,
                        p: 1.5,
                        rowSpacing: 0
                    },
                    sx: {
                        bgcolor: 'background.secondary',
                        border: 'none'
                    },
                    columnSize: 12,
                    setFieldProps: function (state, currValue, field) {
                        console.log('staet>>>>>', state);
                        return {
                            type: this.type,
                            containerProps: {
                                my: currValue ? 1.5 : 0
                            },
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    label: 'RM name: ',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    // valueGetter(formValues, field) {
                                    //     const currValue = formValues?.[this.name];
                                    //     if (currValue) return dayjs(currValue).format('DD MMM YYYY - h:mm A')
                                    //     else return '-'
                                    // },
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    label: 'SAM name: ',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'ModelName',
                                    label: 'SAM contact no.',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'InspectorName',
                                    label: 'State and city :',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'InspectorName',
                                    label: 'Dealer name & code:',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'InspectorName',
                                    label: 'Branch:',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'InspectorName',
                                    label: 'Model name & code:',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'InspectorName',
                                    label: 'Chassis number:',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }]
                        };
                    },
                    elements: []
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    justifyContent: 'end',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: 'expand-button',
                            columnSize: 0,
                            color: 'secondary',
                            size: 'small',
                            sx: {
                                p: 0,
                                fontSize: 'sm'
                            },
                            setFormState: function (formValues) {
                                return {
                                    expanded: !(formValues !== null && formValues !== void 0 && formValues.expanded)
                                };
                            },
                            setFieldProps: function (formValues) {
                                return {
                                    type: this.type,
                                    children: formValues !== null && formValues !== void 0 && formValues.expanded ? ['View less', /*#__PURE__*/ React.createElement(ExpandLess, null)] : ['View more', /*#__PURE__*/ React.createElement(ExpandMore, null)]
                                };
                            }
                        }]
                }]
        } : {
            type: FormItemTypes.Custom,
            name: '',
            columnSize: 12,
            element: RelatedDocumentsCatalogReceivedEdit
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: 'header',
            columnSize: 12,
            paddingInline: '24px',
            pb: 2,
            position: 'relative',
            m: 0,
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    xs: 12,
                    sm: 6,
                    md: 6,
                    lg: 6,
                    alignItems: 'center',
                    gap: '16px',
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(LeftArrow, null),
                            sx: {
                                color: 'secondary.600'
                            },
                            columnSize: 0
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            display: 'flex',
                            columnSize: true,
                            alignItems: 'center',
                            sx: {
                                justifyContent: {
                                    xs: "space-between",
                                    sm: 'start'
                                }
                            },
                            gap: '12px',
                            elements: [{
                                    type: FormItemTypes.Box,
                                    name: '',
                                    display: 'flex',
                                    alignItems: 'center',
                                    columnSize: 0,
                                    gap: '12px',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            value: 'IR-909090',
                                            fontWeight: 'strong',
                                            fontSize: isMobile ? 'lg' : 'xxl',
                                            columnSize: 0
                                        }, {
                                            type: FormItemTypes.Chip,
                                            name: '',
                                            label: 'Open',
                                            color: 'info',
                                            columnSize: 0,
                                            sx: {
                                                borderRadius: '6px',
                                                height: '24px',
                                                fontWeight: 'medium'
                                            },
                                            size: 'medium'
                                        }]
                                }, isMobile ? {
                                    type: FormItemTypes.IconButton,
                                    name: '',
                                    children: /*#__PURE__*/ React.createElement("img", {
                                        src: MoreIconNew,
                                        alt: ""
                                    }),
                                    columnSize: 0,
                                    sx: {
                                        ":hover": {
                                            bgcolor: 'transparent'
                                        }
                                    }
                                } : null]
                        }]
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    sx: {
                        flexDirection: {
                            xs: 'column',
                            sm: 'row',
                            md: 'row',
                            lg: 'row'
                        },
                        gap: {
                            xs: "4px",
                            sm: '24px',
                            md: '24px',
                            lg: '24px'
                        }
                    },
                    xs: 12,
                    sm: 6,
                    md: 6,
                    lg: 6,
                    textAlign: 'center',
                    justifyContent: 'end',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'DOC NO:',
                            value: null,
                            // value: `${documentDetailsGetById?.data?.SourceDocumentNo ? documentDetailsGetById?.data?.SourceDocumentNo : ""}`,
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'strong'
                            },
                            columnSize: isMobile ? 12 : 0
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'DOC DATE:',
                            value: '',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'strong'
                            },
                            columnSize: isMobile ? 12 : 0
                        }
                        // !isMobile ?
                        //     // (!(documentDetailsGetById?.data?.Key == StatusEnum.Awaiting || documentDetailsGetById?.data?.Key === StatusEnum.Cancelled)) && {
                        //     {
                        //         type: FormItemTypes.IconButton,
                        //         name: '',
                        //         children: <img src={MoreIconNew} alt="" />,
                        //         columnSize: 0,
                        //         sx: {
                        //             ":hover": {
                        //                 bgcolor: 'transparent'
                        //             }
                        //         },
                        //     } : null
                    ]
                }]
        }, !isMobile ? {
            type: FormItemTypes.Box,
            name: '',
            height: '68px',
            padding: '16px 24px',
            gap: '12px',
            bgcolor: 'secondary.100',
            borderTop: '1px solid ',
            borderBottom: '1px solid ',
            borderColor: 'secondary.200',
            columnSize: 12,
            justifyContent: 'end',
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    justifyContent: 'end',
                    display: 'flex',
                    columnSize: 12,
                    gap: '12px',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: '',
                            variant: 'text',
                            children: 'Quick links',
                            columnSize: 0,
                            sx: {
                                bgcolor: 'transparent',
                                fontWeight: 'medium'
                            },
                            startIcon: /*#__PURE__*/ React.createElement(LinkSvg, null),
                            setFieldProps: function (state) { return ({
                                type: FormItemTypes.Button
                                // disabled: state?.selectedVehicle ? false : true,
                            }); }
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(Download, null),
                            columnSize: 0,
                            color: 'secondary',
                            variant: 'outlined',
                            sx: {
                                padding: '8px'
                            },
                            disabled: true
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(ShareIcon, {
                                height: 20,
                                width: 20,
                                color: "secondary"
                            }),
                            columnSize: 0,
                            color: 'secondary',
                            variant: 'outlined',
                            sx: {
                                padding: '8px'
                            },
                            disabled: true
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(PrintIconSVG, null),
                            columnSize: 0,
                            color: 'secondary',
                            variant: 'outlined',
                            sx: {
                                padding: '8px'
                            },
                            disabled: true
                        }, {
                            type: FormItemTypes.Divider,
                            name: '',
                            variant: 'fullWidth',
                            orientation: 'vertical',
                            columnSize: 0
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: 'Resend to PSG',
                            columnSize: 0,
                            color: 'primary',
                            variant: 'outlined',
                            onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Dialog',
                                                Component: CloseAFRPopup,
                                                componentProps: {
                                                    subtitle: 'Failure before corrective actions',
                                                    remarkTitle: 'CQA remarks'
                                                }
                                            }))];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); },
                            setFieldProps: function (state) {
                                console.log("state i sss", state);
                                return {
                                    type: FormItemTypes.Button
                                    // hidden: state?.SelectedButton == "Received" ? false : true
                                };
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: 'Accept',
                            columnSize: 0,
                            color: 'primary',
                            variant: 'outlined',
                            onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Dialog',
                                                Component: AcceptIRPoup
                                            }))];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); },
                            setFieldProps: function (state) { return ({
                                type: FormItemTypes.Button
                                // hidden: state?.SelectedButton == "Received" ? false : true
                            }); }
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: 'Close IR',
                            columnSize: 0,
                            color: 'primary',
                            variant: 'outlined',
                            onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Dialog',
                                                Component: closeIRPoup
                                            }))];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); },
                            setFieldProps: function (state) { return ({
                                type: FormItemTypes.Button
                                // hidden: state?.SelectedButton == "Received" ? false : true
                            }); }
                        }]
                }]
        } : null, {
            type: FormItemTypes.Tabs,
            name: 'Tabs',
            columnSize: 12,
            valueExpr: 'id',
            displayExpr: 'Name',
            panelGridProps: {
                spacing: 2,
                px: isMobile ? 2 : 3,
                pb: isMobile ? '65px' : 0
            },
            tabs: [{
                    id: 'general',
                    Name: 'General',
                    elements: Genral_Tab
                }, {
                    id: 'Problem_description_OR_change_sequence',
                    Name: 'Problem description OR change sequence',
                    elements: Problem_description_OR_change_sequence
                }, {
                    id: 'History',
                    Name: 'History',
                    elements: History_Tab
                }, {
                    id: 'RelatedDocuments',
                    Name: 'Related documents',
                    elements: Related_documents
                }]
        }, isMobile ? {
            type: FormItemTypes.Box,
            name: '',
            display: 'flex',
            columnSize: 12,
            position: 'fixed',
            bottom: 0,
            right: 0,
            bgcolor: 'white',
            p: 2,
            width: '100%',
            justifyContent: 'space-between',
            sx: {
                borderTop: '1px solid ',
                borderColor: 'secondary.200',
                gap: '16px'
            },
            setFieldProps: function (state) { return ({
                type: FormItemTypes.ContainerItem,
                elements: [{
                        type: FormItemTypes.Button,
                        id: "CloseIR",
                        name: '',
                        children: 'Resend to PSG ',
                        variant: 'outlined',
                        color: 'primary',
                        columnSize: 0
                    }, {
                        type: FormItemTypes.Button,
                        id: "createDocument",
                        name: '',
                        children: 'Accept',
                        variant: 'outlined',
                        color: 'primary',
                        columnSize: 0,
                        setFormState: function (formValues) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                            return [2 /*return*/];
                        }); }); }
                    }, {
                        type: FormItemTypes.Button,
                        id: "createDocument",
                        name: '',
                        children: 'Close IR',
                        variant: 'outlined',
                        color: 'primary',
                        columnSize: 0,
                        setFormState: function (formValues) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                            return [2 /*return*/];
                        }); }); }
                    }]
            }); }
        } : null];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        mode: "edit",
        gridProps: {
            spacing: 0
        },
        formProps: {
            sx: {
                bgcolor: ' secondary.50'
            }
        }
    }));
};
export default CQAReceivedEdit;
